"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var api_1 = require("@react-google-maps/api");
var classnames_1 = __importDefault(require("classnames"));
var i18n_1 = __importDefault(require("../../i18n"));
var AddressSearch_1 = __importStar(require("./AddressSearch"));
var MultiSelectField_1 = __importDefault(require("./MultiSelectField"));
var HomeCheckbox_1 = __importDefault(require("../HomeCheckbox"));
var GoogleGeocoding_1 = __importDefault(require("../../constants/GoogleGeocoding"));
var store_1 = require("../../app/store");
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var languageSlice_1 = require("../../features/languages/languageSlice");
var filters_1 = require("../../helpers/filters");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var T = 'HOME.SEARCH_FORM';
var EMPTY = { stateIds: [], districtIds: [], place: null };
// Regions come from the filter schema that app.tsx already loads on start.
var selectStates = function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.searchParams.filters) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.options) !== null && _c !== void 0 ? _c : []; };
// The search ANDs state_id and district_id. To get "Yerevan: Arabkir OR all of
// Kotayk", a ticked region without ticked communities sends all its communities.
// With no community ticked anywhere, regions alone are enough.
var toSearchDistricts = function (selection, districtsByState) {
    if (!selection.districtIds.length)
        return [];
    return selection.stateIds.reduce(function (acc, stateId) {
        var _a;
        var all = ((_a = districtsByState[stateId]) !== null && _a !== void 0 ? _a : []).map(function (d) { return d.govId; });
        var ticked = all.filter(function (id) { return selection.districtIds.includes(id); });
        return acc.concat(ticked.length ? ticked : all);
    }, []);
};
var normalize = function (text) { return (text !== null && text !== void 0 ? text : '').trim().toLowerCase(); };
// True when any language variant of our place equals the Google name.
var sameName = function (place, name) {
    var _a;
    return __spreadArray([place.text], Object.values((_a = place.translations) !== null && _a !== void 0 ? _a : {})).some(function (variant) { return normalize(variant) === normalize(name); });
};
var HomeLocationPicker = function (_a) {
    var label = _a.label, onChange = _a.onChange;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = store_1.useAppThunkDispatch();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var states = react_redux_1.useSelector(selectStates);
    var fieldsRef = react_1.useRef(null);
    var districtPanelRef = react_1.useRef(null);
    // Same loader options as the old home page banner, so Google Maps loads once.
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    var _b = react_1.useState(null), panel = _b[0], setPanel = _b[1];
    var _c = react_1.useState(EMPTY), selection = _c[0], setSelection = _c[1];
    var _d = react_1.useState({}), districtsByState = _d[0], setDistrictsByState = _d[1];
    var _e = react_1.useState(''), communityQuery = _e[0], setCommunityQuery = _e[1];
    // Region whose communities the panel should scroll to (set by a region chip click).
    var _f = react_1.useState(null), focusStateId = _f[0], setFocusStateId = _f[1];
    // Remounts the address search so clearing also empties its typed text.
    var _g = react_1.useState(0), addressKey = _g[0], setAddressKey = _g[1];
    var hasSelection = selection.stateIds.length > 0 ||
        selection.districtIds.length > 0 ||
        !!selection.place;
    // Clears regions, districts and the street in one go.
    var clearAll = function () {
        setSelection(EMPTY);
        setPanel(null);
        setCommunityQuery('');
        setAddressKey(function (k) { return k + 1; });
    };
    // Selection applies immediately: the form always holds the current location.
    react_1.useEffect(function () {
        onChange({
            stateIds: selection.stateIds,
            districtIds: toSearchDistricts(selection, districtsByState),
            place: selection.place,
        });
    }, [selection, districtsByState]);
    // A click outside the region/community fields closes the open panel.
    react_1.useEffect(function () {
        if (!panel)
            return undefined;
        var onDocumentClick = function (e) {
            var _a;
            if (!((_a = fieldsRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)))
                setPanel(null);
        };
        document.addEventListener('mousedown', onDocumentClick);
        return function () { return document.removeEventListener('mousedown', onDocumentClick); };
    }, [panel]);
    // 1. A region chip was clicked: scroll the communities panel so that region's
    //    group is on top. Re-runs when communities load, since groups above it
    //    change height then.
    // 2. Closing the panel forgets the region, so opening it with the arrow
    //    later starts from the top as before.
    react_1.useEffect(function () {
        if (panel !== 'district') {
            setFocusStateId(null);
            return;
        }
        var container = districtPanelRef.current;
        if (!focusStateId || !container)
            return;
        var group = container.querySelector("[data-state-id=\"" + focusStateId + "\"]");
        if (group)
            container.scrollTop = group.offsetTop;
    }, [panel, focusStateId, districtsByState]);
    var placeName = function (place) { var _a; return ((_a = place === null || place === void 0 ? void 0 : place.translations) === null || _a === void 0 ? void 0 : _a[currentLanguage]) || (place === null || place === void 0 ? void 0 : place.text) || ''; };
    var stateById = function (id) { return states.find(function (s) { return s.govId === id; }); };
    var districtById = function (id) {
        return Object.values(districtsByState)
            .reduce(function (acc, list) { return acc.concat(list); }, [])
            .find(function (d) { return d.govId === id; });
    };
    // Communities are loaded with the search page's thunk; its return value is
    // used directly (the store copy belongs to the search page). Passing several
    // regions loads them in one request.
    var loadDistricts = function (stateIds) { return __awaiter(void 0, void 0, void 0, function () {
        var missing, result, loaded;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    missing = stateIds.filter(function (id) { return !districtsByState[id]; });
                    if (!missing.length)
                        return [2 /*return*/, districtsByState];
                    return [4 /*yield*/, dispatch(searchParamsSlice_1.getDistricts(missing, true))];
                case 1:
                    result = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                    loaded = missing.reduce(function (acc, id) {
                        var _a;
                        return (__assign(__assign({}, acc), (_a = {}, _a[id] = result.filter(function (d) { return d.parent_state_id === id; }), _a)));
                    }, {});
                    // Merge into the latest state, not the snapshot from the click: regions
                    // ticked quickly load in parallel and must not overwrite each other.
                    setDistrictsByState(function (current) { return (__assign(__assign({}, current), loaded)); });
                    return [2 /*return*/, __assign(__assign({}, districtsByState), loaded)];
            }
        });
    }); };
    // 1. Ticking a region drops the street (they exclude each other) and loads
    //    the region's communities.
    // 2. Unticking a region also unticks its communities.
    var toggleState = function (stateId) {
        var _a;
        if (selection.stateIds.includes(stateId)) {
            var own_1 = ((_a = districtsByState[stateId]) !== null && _a !== void 0 ? _a : []).map(function (d) { return d.govId; });
            setSelection(__assign(__assign({}, selection), { stateIds: selection.stateIds.filter(function (id) { return id !== stateId; }), districtIds: selection.districtIds.filter(function (id) { return !own_1.includes(id); }) }));
            return;
        }
        setSelection(__assign(__assign({}, selection), { place: null, stateIds: __spreadArray(__spreadArray([], selection.stateIds), [stateId]) }));
        loadDistricts([stateId]);
    };
    var toggleDistrict = function (districtId) {
        setSelection(__assign(__assign({}, selection), { districtIds: selection.districtIds.includes(districtId)
                ? selection.districtIds.filter(function (id) { return id !== districtId; })
                : __spreadArray(__spreadArray([], selection.districtIds), [districtId]) }));
    };
    var toggleAllDistricts = function (stateId) {
        var _a;
        var own = ((_a = districtsByState[stateId]) !== null && _a !== void 0 ? _a : []).map(function (d) { return d.govId; });
        var allTicked = own.every(function (id) { return selection.districtIds.includes(id); });
        var rest = selection.districtIds.filter(function (id) { return !own.includes(id); });
        setSelection(__assign(__assign({}, selection), { districtIds: allTicked ? rest : __spreadArray(__spreadArray([], rest), own) }));
    };
    // A street becomes a chip that searches by its box on the map.
    // Details (box, address parts) come from the suggestion's source: Google or OSM.
    var pickStreet = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedPlace, area;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, item.resolve()];
                case 1:
                    selectedPlace = _a.sent();
                    if (!selectedPlace)
                        return [2 /*return*/];
                    area = item.secondaryText.split(',')[0];
                    setPanel(null);
                    setSelection({
                        stateIds: [],
                        districtIds: [],
                        place: {
                            label: [item.mainText, area].filter(Boolean).join(', '),
                            geometry: selectedPlace.geometry,
                            address: __assign(__assign({}, filters_1.extractStateDistrictFromPlace(selectedPlace)), { placeName: selectedPlace.main_text }),
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    // 1. A city/community that exists in our lists gets ticked there.
    // 2. Communities of all regions are loaded once (one request) to find a match.
    // 3. Anything we can't match (e.g. a village) falls back to a map-box chip.
    var pickArea = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var name, state, byState, district;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = item.mainText;
                    state = states.find(function (s) { return sameName(s, name); });
                    if (state) {
                        if (!selection.stateIds.includes(state.govId)) {
                            toggleState(state.govId);
                        }
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, loadDistricts(states.map(function (s) { return s.govId; }))];
                case 1:
                    byState = _a.sent();
                    district = Object.values(byState)
                        .reduce(function (acc, list) { return acc.concat(list); }, [])
                        .find(function (d) { return sameName(d, name); });
                    if (district) {
                        setSelection(function (current) { return ({
                            place: null,
                            stateIds: current.stateIds.includes(district.parent_state_id)
                                ? current.stateIds
                                : __spreadArray(__spreadArray([], current.stateIds), [district.parent_state_id]),
                            districtIds: current.districtIds.includes(district.govId)
                                ? current.districtIds
                                : __spreadArray(__spreadArray([], current.districtIds), [district.govId]),
                        }); });
                        return [2 /*return*/];
                    }
                    pickStreet(item);
                    return [2 /*return*/];
            }
        });
    }); };
    var onAddressSelect = function (item) {
        if (item.kind === 'street') {
            pickStreet(item);
            return;
        }
        pickArea(item);
    };
    var togglePanel = function (next) {
        return setPanel(function (current) { return (current === next ? null : next); });
    };
    // A region chip opens the communities panel at that region's group.
    // Chips are rendered in the order of selection.stateIds, so the index maps directly.
    var openRegionDistricts = function (chipIndex) {
        var _a;
        setFocusStateId((_a = selection.stateIds[chipIndex]) !== null && _a !== void 0 ? _a : null);
        setPanel('district');
    };
    var countDistrictsOf = function (stateId) {
        var _a;
        return ((_a = districtsByState[stateId]) !== null && _a !== void 0 ? _a : []).filter(function (d) {
            return selection.districtIds.includes(d.govId);
        }).length;
    };
    // Community search matches any language, so "Arabkir" finds "Արաբկիր".
    var matchesQuery = function (district) {
        var _a;
        var query = normalize(communityQuery);
        if (!query)
            return true;
        return __spreadArray([
            district.text
        ], Object.values((_a = district.translations) !== null && _a !== void 0 ? _a : {})).some(function (name) { return normalize(name).includes(query); });
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.picker },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.header_label }, label),
            hasSelection && (react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.clear, onClick: clearAll }, t(T + ".CLEAR")))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.fields, ref: fieldsRef },
            react_1.default.createElement(MultiSelectField_1.default, { label: t(T + ".REGION"), values: selection.stateIds.map(function (id) {
                    return placeName(stateById(id));
                }), placeholder: t(T + ".SELECT"), isOpen: panel === 'state', onToggle: function () { return togglePanel('state'); }, onChipClick: openRegionDistricts }),
            react_1.default.createElement(MultiSelectField_1.default, { label: t(T + ".COMMUNITY"), values: selection.districtIds.map(function (id) {
                    return placeName(districtById(id));
                }), placeholder: selection.stateIds.length
                    ? t(T + ".ALL_COMMUNITIES")
                    : t(T + ".SELECT"), isOpen: panel === 'district', onToggle: function () { return togglePanel('district'); } }),
            panel === 'state' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.panel },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.grid }, states.map(function (s) {
                    var _a;
                    var isChecked = selection.stateIds.includes(s.govId);
                    var count = countDistrictsOf(s.govId);
                    return (react_1.default.createElement("button", { key: s.govId, type: "button", className: classnames_1.default(styles_module_scss_1.default.option, (_a = {},
                            _a[styles_module_scss_1.default.option_checked] = isChecked,
                            _a)), onClick: function () { return toggleState(s.govId); } },
                        react_1.default.createElement(HomeCheckbox_1.default, { checked: isChecked }),
                        react_1.default.createElement("span", { className: styles_module_scss_1.default.option_text }, placeName(s)),
                        isChecked && count > 0 && (react_1.default.createElement("span", { className: styles_module_scss_1.default.option_count }, t(T + ".COMMUNITIES_COUNT", {
                            count: count,
                        })))));
                })))),
            panel === 'district' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.panel, ref: districtPanelRef },
                !selection.stateIds.length && (react_1.default.createElement("p", { className: styles_module_scss_1.default.hint }, t(T + ".PICK_REGION_FIRST"))),
                selection.stateIds.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.community_search },
                        react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", "aria-hidden": true },
                            react_1.default.createElement("circle", { cx: "11", cy: "11", r: "7" }),
                            react_1.default.createElement("path", { d: "M20 20l-3.5-3.5" })),
                        react_1.default.createElement("input", { type: "text", placeholder: t(T + ".COMMUNITY_SEARCH"), value: communityQuery, onChange: function (e) {
                                return setCommunityQuery(e.target.value);
                            } })),
                    selection.stateIds.map(function (stateId) {
                        var _a;
                        var own = (_a = districtsByState[stateId]) !== null && _a !== void 0 ? _a : [];
                        var visible = own.filter(matchesQuery);
                        var allTicked = own.length > 0 &&
                            own.every(function (d) {
                                return selection.districtIds.includes(d.govId);
                            });
                        return (react_1.default.createElement("div", { key: stateId, className: styles_module_scss_1.default.group, "data-state-id": stateId },
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.group_header },
                                react_1.default.createElement("span", null, placeName(stateById(stateId))),
                                own.length > 0 && (react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.link, onClick: function () {
                                        return toggleAllDistricts(stateId);
                                    } }, allTicked
                                    ? t(T + ".DESELECT_ALL")
                                    : t(T + ".SELECT_ALL")))),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.grid }, visible.map(function (d) {
                                var _a;
                                var isChecked = selection.districtIds.includes(d.govId);
                                return (react_1.default.createElement("button", { key: d.govId, type: "button", className: classnames_1.default(styles_module_scss_1.default.option, (_a = {},
                                        _a[styles_module_scss_1.default.option_checked] = isChecked,
                                        _a)), onClick: function () {
                                        return toggleDistrict(d.govId);
                                    } },
                                    react_1.default.createElement(HomeCheckbox_1.default, { checked: isChecked }),
                                    react_1.default.createElement("span", { className: styles_module_scss_1.default.option_text }, placeName(d))));
                            }))));
                    })))))),
        isLoaded && (react_1.default.createElement(AddressSearch_1.default, { key: addressKey, onSelect: onAddressSelect })),
        selection.place && (react_1.default.createElement("div", { className: styles_module_scss_1.default.place_row },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.place_chip },
                react_1.default.createElement(AddressSearch_1.PinIcon, null),
                selection.place.label,
                react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.chip_remove, onClick: function () {
                        return setSelection(function (s) { return (__assign(__assign({}, s), { place: null })); });
                    } }, "\u00D7")),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.hint }, t(T + ".PLACE_EXCLUSIVE_HINT"))))));
};
exports.default = HomeLocationPicker;
